import { WelcomepageDialogComponent } from "src/app/welcomepage-dialog/welcomepage-dialog.component";
import { map, filter } from "rxjs/operators";
import { startWith } from "rxjs/operators";
import { FormControl, ValidatorFn, AbstractControl } from "@angular/forms";
import { SellerRewardsDialogComponent } from "./../../../shared/components/seller-rewards-dialog/seller-rewards-dialog.component";
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { trigger, transition, animate, style } from "@angular/animations";
import {
  LocalService,
  StoreService,
  ManagerService,
  UserService,
  DashboardService,
  AuthService,
} from "../../services";
import { Errors } from "../../models";
import { CONSTANTS } from "../../../config";
import { TranslateService } from "@ngx-translate/core";
import { Subscription, Observable } from "rxjs";
// import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import { MatPaginator, MatDialog } from "@angular/material";
import countries from "../../../../assets/countries.json";
import { AcknowledgementService } from "../../services/acknowledgement.service";
import { AcknowldgementDialogComponent } from "src/app/acknowldgement-dialog/acknowldgement-dialog.component";
import { OidcService } from "../../services/oidc.service";
import { CommonRouteService } from "../../services/common-route.service";
import { PreferenceStateService } from "../../services/preference-state.service";
export interface User {
  name: string;
  code: string;
}

export function forbiddenNamesValidator(names: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    // below findIndex will check if control.value is equal to one of our options or not
    if (control.value === "") {
    } else {
      const index = names.findIndex((name) => {
        return new RegExp("^" + name + "$").test(control.value);
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    }
  };
}
export function forbiddenBegeoIDValidator(names: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === "") {
    } else {
      // below findIndex will check if control.value is equal to one of our options or not
      const index = names.findIndex((name) => {
        return new RegExp("^" + name["partnerNameBegeoId"] + "$").test(
          control.value
        );
      });
      return index < 0 ? { forbiddenIDs: { value: control.value } } : null;
    }
  };
}
@Component({
  selector: "cisco-steer-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  animations: [
    trigger("slideLeft", [
      transition(":enter", [
        style({ transform: "translateX(100%)" }),
        animate("200ms ease-in", style({ transform: "translateX(0%)" })),
      ]),
      transition(":leave", [
        animate("200ms ease-in", style({ transform: "translateX(100%)" })),
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit {
  userData;
  isLoggedIn: boolean = false;
  errors: Errors = { errors: {} };
  dropDownFlag: Boolean = false;
  showMenu: Boolean = false;
  managerFlag: Boolean = false;
  sellerFlag: Boolean = false;
  adminFlag: Boolean = false;
  showDistributePoints: Boolean = false;
  isSalesChallenge: Boolean = false;
  isActivityChallenge: Boolean = false;
  switchRole;
  isChallengePreference: Boolean = false;
  isFooterRoute: Boolean = true;
  isActivityChallengeUser: Boolean = false;
  isSalesChallengeUser: Boolean = false;
  distributePointsPreference;
  isShown: Boolean = false;
  default = "English";
  lang: string;
  userActivatedSubscription: Subscription;
  subscription: Subscription;
  adminFlagSubscription: Subscription;
  isShowNotifications: boolean = false;
  notificationData: any = {};
  notificationPage: number;
  notificationSize: number = 5;
  notificationsCount: number;
  beGeoIdList: any = [];
  selectedBgeoId: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild("yourPatnerInfoPopUp") yourPatnerInfoPopUp: ElementRef;
  showBeGeoIds: boolean = false;
  selectedCountry: string;
  isCiscoAdmin: boolean = false;
  isCiscoAdminText: boolean = false;
  ciscoAdminNavText: boolean = false;
  @HostListener("document:click", ["$event"]) clickedOutside($event) {
    this.dropDownFlag = false;
    this.isShown = false;
    this.isShowNotifications = false;
    if (
      this.yourPatnerInfoPopUp !== undefined &&
      (this.yourPatnerInfoPopUp.nativeElement.contains($event.target) ||
        $event.target.className === "mat-option-text" ||
        $event.target.classList.contains("cdk-overlay-backdrop"))
    ) {
      return;
    } else {
      this.showBeGeoIds = false;
    }
    // this.showBeGeoIds = false;
  }
  options = [];
  myControl = new FormControl();
  filteredOptions: Observable<any>;

  regionsList = [];
  regionName: string = "";
  begeoIdControl = new FormControl();
  beGeoIDoptions: any = [];
  beGeoIDfilteredOptions: Observable<any>;
  selectedRegion: string = "";

  pamUserData: any;
  notificationFlag: boolean = false;
  approverFlag: boolean = false;
  onlyApprover: boolean = false;
  badgingAcessControl: string = "";
  dropdownOptions: string[] = [];
  companyPreferenceResponse;
  constructor(
    private router: Router,
    private storeService: StoreService,
    private managerService: ManagerService,
    private userService: UserService,
    public translate: TranslateService,
    private dashboardService: DashboardService,
    public dialog: MatDialog,
    private acknowledgementService: AcknowledgementService,
    private authService: AuthService,
    readonly oidcService: OidcService, // private popupMessageService: PopupMessageService,
    readonly commonRouteService: CommonRouteService,
    private preferenceService: PreferenceStateService
  ) {
    translate.setDefaultLang("English");
    this.isLoggedIn = this.authService.isAuthenticated;
  }
  profileFlag: boolean = false;
  getUserData() {
    this.subscription = this.storeService.getUserObj().subscribe((res: any) => {
      if (res != null) {
        this.userData = res;
        this.pamUserData = res["pamDefaultSelection"];
        if (
          res.active == true &&
          res.hasOwnProperty("userType") &&
          res.userType == "PAM"
        ) {
          if (res.pamActivity.createProfleClicked) {
            this.profileFlag = true;
          }
          if (res && res.active && res.company.profileComplete) {
            this.notificationFlag = true;
          } else {
            this.notificationFlag = false;
          }
          this.managerFlag = true;

          this.openDialog();
        }
      }
    });
  }

  ngOnInit() {
    this.getUserData();
    var lang = localStorage.getItem("selectedLanguage");
    if (lang != "" && lang != null) this.useLanguage(lang, false);
    this.lang = lang;
    let approverRole = LocalService.get("approverRole");
    let approver = LocalService.get("onlyApprover");
    if (approverRole) {
      approverRole.approverRole
        ? (this.approverFlag = true)
        : (this.approverFlag = false);
    }

    this.userActivatedSubscription = this.storeService.userActivated.subscribe(
      (role) => {
        if (role != "") {
          this.switchRole = role;
          if (this.approverRoleStatus) {
            this.switchRole = "approver";
          }
        }

        if (
          this.userData.hasOwnProperty("userType") &&
          this.userData.userType == "PAM"
        ) {
          this.pamUserData = this.userData.pamDefaultSelection;
          this.selectedRegion = this.userData.pamDefaultSelection.theater;
          this.selectedCountry = this.userData.pamDefaultSelection.countryGroup;
          this.selectedBgeoId =
            this.userData.pamDefaultSelection.pamBeGeoIdsDTO.beGeoIds[0].partnerNameBegeoId;

          if (this.switchRole == "seller") {
            this.switchRole = "manager";
          }
          if (this.switchRole == "manager") {
            this.partnerLeaderFlag = true;
          }
          if (this.approverRoleStatus) {
            this.switchRole = "approver";
          }
        }

        if (this.switchRole === "home")
          this.userData = LocalService.get("userProfile");
      }
    );

    this.getRoles();
    this.storeService.updateRole.subscribe((roleUpdated) => {
      if (roleUpdated) this.getRoles();
    });

    this.storeService.isTabActivated.subscribe((flag) => {
      if (flag) {
        this.getCompanyPreferences();
        this.getUserPreferences(6);
        this.getUserPreferences(7);
      }
    });

    if (this.notificationFlag && this.userData.isUserVerified) {
      this.getNotificationsCount();
    }

    if (this.isLoggedIn) {
      if (this.userData.roles != null) {
        if (this.userData.roles.find((item) => item.name === "CISCO_ADMIN")) {
          this.ciscoAdminNavText = true;
          // this.adminFlagSubscription=this.storeService.getIsciscoAdminFlag().subscribe((data)=>{
          //   console.log("subscribedata",data);
          //   if(data.isCiscoAdmin==true){
          //     this.isCiscoAdmin=true;
          //   }

          // })
        }
      }
      // this.getManagerNotifications(true,null);
      if (this.userData.createSalesChg) {
        this.isCiscoAdminText = true;
      }
      if (approver) {
        this.onlyApprover = true;
        this.approverRoleStatus = false;
        this.approverFlag = false;
      }
      if (
        approverRole &&
        approverRole.approverRole &&
        this.userData.roles.find((item) => item.name === "CISCO_ADMIN") &&
        !(
          this.userData.hasOwnProperty("userType") &&
          this.userData.userType == "PAM"
        ) &&
        !this.managerFlag &&
        !this.sellerFlag
      ) {
        this.userNavigation("createsaleschg");
      }
    }

    this.getcompanyPrefById();
    this.setMonetaryBadgingDropdown();
  }

  ngAfterViewInit() {}
  getRoles() {
    this.userData = LocalService.get("userProfile");
    if (
      this.userData &&
      this.userData.active &&
      this.userData.company.profileComplete
    ) {
      this.notificationFlag = true;
      if (this.userData.isUserVerified) {
        this.getCompanyPreferences();
        this.getUserPreferences(6);
        this.getUserPreferences(7);
      }
      if (
        this.userData.hasOwnProperty("userType") &&
        this.userData.userType == "PAM"
      ) {
        this.managerFlag = true;

        if (this.userData.pamActivity.createProfleClicked) {
          this.profileFlag = true;
        }
      } else {
        const managerRoles = CONSTANTS.manager;
        const managerRolesIntersection = this.isAnyIntersection(managerRoles);
        this.managerFlag = managerRolesIntersection.length ? true : false;
        const sellerRoles = CONSTANTS.seller;
        const sellerRolesIntersection = this.isAnyIntersection(sellerRoles);
        this.sellerFlag = sellerRolesIntersection.length ? true : false;
        const admin = "COMPANY_ADMIN";
        this.adminFlag = this.userData.roles.find(
          (item) => item.name === admin
        );
      }
    }
  }

  getCompanyPreferences() {
    this.managerService.getCompanyTypePreferences().subscribe(
      (data) => {
        const tabName = "COMPANY_DISTRIBUTE_POINTS";
        const preferenceType = data.filter((item) => item.name === tabName);
        const preference = preferenceType.map((item) => item.id)[0];
        if (this.userData.company && this.userData.company.id) {
          const companyParams = {
            companyId: this.userData.company.id,
            preferenceId: preference,
          };
          this.managerService.getCompanyPreferences(companyParams).subscribe(
            (preferences) => {
              this.showDistributePoints = preferences.companyPreferences.map(
                (item) => item.enabled
              )[0];
              this.distributePointsPreference =
                preferences.companyPreferences.find(
                  (item) =>
                    item.id === 8 && item.name === "COMPANY_DISTRIBUTE_POINTS"
                );
              return this.distributePointsPreference;
            },
            (err) => (this.errors = err)
          );
        }
      },
      (err) => (this.errors = err)
    );
    if (this.userData.company && this.userData.company.id) {
      const companyParams = {
        companyId: this.userData.company.id,
      };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data) => {
          const preferences = data.companyPreferences.map(
            (item) => item.enabled
          );
          this.isSalesChallenge = preferences[0];
          this.isActivityChallenge = preferences[1];
          const preference = data.companyPreferences.find(
            (item) => item.name === "COMPANY_SALES_CHALLENGES_AND_REWARDS"
          );
          if (preference) this.isChallengePreference = preference.enabled;
          // this.showDistributePoints = preferences[5];
        },
        (err) => (this.errors = err)
      );
    }
  }

  getUserPreferences(id) {
    const params = {
      userId: this.userData.id,
      preferenceId: id,
    };
    this.managerService.getUserPreferences(params).subscribe(
      (data) => {
        if (id === 6) this.isSalesChallengeUser = data.enabled;
        if (id === 7) this.isActivityChallengeUser = data.enabled;
      },
      (err) => (this.errors = err)
    );
  }

  isAnyIntersection(roles) {
    return this.userData.roles.filter((element) =>
      roles.includes(element.name)
    );
  }

  //Navitage to Home page/manager-page/seller-page
  goHome() {
    if (this.managerFlag)
      return this.router.navigateByUrl("/home/manager/manage-challenges");
    else if (this.sellerFlag)
      return this.router.navigateByUrl("/home/seller/challenges");
    else if (this.userData.id) return this.router.navigateByUrl("/home");
    else return this.router.navigateByUrl("/profile");
  }

  logoutUser() {
    this.storeService.unsubscribeRoute.next(true);
    this.storeService.changeProfileImage("");
    LocalService.flush("token");
    LocalService.flush("userProfile");
    LocalService.flush("selectedFile");
    LocalService.flush("pamData");
    LocalService.flush("approverRole");
    LocalService.flush("onlyApprover");
    LocalService.flush("ciscoAdminRole");
    this.authService.clearAll();
    const currentURL = window.location.href;
    if (currentURL.indexOf("cisco.com") > -1) {
      window.location.href = "https://www.cisco.com/autho/logout.html";
    } else {
      this.userService.logout().subscribe(
        (data) => {},
        (err) => (this.errors = err)
      );
      this.router.navigate(["/"]);
    }
  }

  useLanguage(language: string, reload = true) {
    localStorage.setItem("selectedLanguage", language);
    this.translate.use(language);
    this.default = language;
    if (language == "Korean") this.default = "한국어";
    else if (language == "Japanese") this.default = "日本語";
    if (reload === true) window.location.reload();
  }

  multinagShow(evnt, state) {
    evnt.stopPropagation();
    if (state == 1) {
      this.isShowNotifications = false;
      this.isShown = !this.isShown;
      this.dropDownFlag = false;
      this.showBeGeoIds = false;
    } else if (state == 2) {
      this.isShowNotifications = false;
      this.isShown = false;
      this.dropDownFlag = !this.dropDownFlag;
      this.showBeGeoIds = false;
    } else if (state == 3) {
      this.notificationData = {};
      this.isShowNotifications = !this.isShowNotifications;
      this.isShown = false;
      this.dropDownFlag = false;
      if (this.isShowNotifications) this.getManagerNotifications(true, null);
      this.showBeGeoIds = false;
    } else if (state == 4) {
      this.isShowNotifications = true;
      this.isShown = false;
      this.dropDownFlag = false;
      this.showBeGeoIds = false;
    } else if (state == 5) {
      this.showBeGeoIds = !this.showBeGeoIds;
      this.isShowNotifications = false;
      this.isShown = false;
      this.dropDownFlag = false;
      if (this.showBeGeoIds) {
        this.getRegionList();
      }
    }
  }

  getNotificationsCount() {
    this.dashboardService.getNotificationsCount().subscribe(
      (data) => {
        this.notificationsCount = data;
      },
      (err) => (this.errors = err)
    );
  }

  getManagerNotifications(isFirstPage, event) {
    if (isFirstPage) this.notificationPage = 0;
    if (event != null) this.notificationPage = event.pageIndex;
    const params = {
      page: this.notificationPage,
      size: this.notificationSize,
    };
    this.dashboardService.getNotifications(params).subscribe(
      (data) => {
        this.notificationData = data;
        this.updateManagerNotifications(isFirstPage, event);
      },
      (err) => (this.errors = err)
    );
  }

  updateManagerNotifications(isFirstPage, event) {
    // this.notificationSize = event.pageSize;
    if (
      (event != null && event.previousPageIndex < event.pageIndex) ||
      isFirstPage
    ) {
      const params = [];
      this.notificationData.content.forEach((element) => {
        if (!element.viewed) {
          let notification = {
            id: element.id,
            viewed: true,
          };
          params.push(notification);
        }
      });
      if (params.length) {
        this.dashboardService.updateNotification(params).subscribe(
          (data) => {
            this.getNotificationsCount();
            // this.getManagerNotifications(false,null);
          },
          (err) => (this.errors = err)
        );
      }
      //  else  this.getManagerNotifications(false);
    }
    // else this.getManagerNotifications(false);
    //  this.paginator.pageIndex = 0;
  }

  // showMoreNotifications(event) {
  //   this.notificationPage = event.pageIndex;
  //   this.notificationSize = event.pageSize;
  //     const params = {
  //     page: this.notificationPage,
  //     size:this.notificationSize,
  //   };
  //   this.dashboardService.getNotifications(params).subscribe((data) => {
  //     if (data && data.content.length) {
  //       this.notificationData.content = data.content;
  //     }
  //   }, err => this.errors = err);
  // }

  postDeleteNotification(id) {
    var lang = localStorage.getItem("selectedLanguage");
    const notificationParams = {
      id: id,
      viewed: true,
    };
    this.dashboardService.postDeleteNotification(notificationParams).subscribe(
      (data) => {
        // var msg = 'Notification deleted successfully.';
        //     if (lang == 'Korean') msg = '알림이 성공적으로 삭제되었습니다.';
        //     if (lang == 'Japanese') msg = '通知は正常に削除されました。';
        // this.popupMessageService.showSuccess(msg, 'success');
        if (this.notificationData.content.length % 5 == 1) {
          if (this.paginator != undefined) {
            this.notificationPage = this.notificationPage - 1;
            this.paginator.pageIndex = this.paginator.pageIndex - 1;
          }
        }
        this.getNotificationsCount();
        this.getManagerNotifications(false, null);
      },
      (err) => (this.errors = err)
    );
  }

  parseHTML(value) {
    return value.split("<")[0];
  }

  parseLink(value) {
    return value.match(/href='([^']*)/)[1];
  }
  // sowmya
  //on change of beGeio id set company id

  changeCompanyId(compid, geo_id, name, regionNm, compdto, selectedBegeo) {
    var updatedCompId = compid;
    var changedCompId = this.userData;
    var updatedPam = this.pamUserData;
    this.selectedCountry = this.myControl.value;
    this.selectedRegion = this.regionName;
    this.selectedBgeoId = selectedBegeo;
    changedCompId["company"].id = updatedCompId;
    changedCompId["company"]["region"] = regionNm;
    changedCompId["pamDefaultSelection"]["pamBeGeoIdsDTO"]["beGeoIds"][0][
      "companyEligibleChallengesDTO"
    ] = compdto;
    // on change of begeoid set the selected values in the local storage
    updatedPam["theater"] = this.regionName;
    updatedPam["countryGroup"] = this.countrValue;
    updatedPam["pamBeGeoIdsDTO"]["beGeoIds"][0]["beGeoId"] = geo_id;
    updatedPam["pamBeGeoIdsDTO"]["beGeoIds"][0]["partnerName"] = name;
    updatedPam["pamBeGeoIdsDTO"]["beGeoIds"][0]["partnerNameBegeoId"] =
      selectedBegeo;
    //  updatedPam['pamBeGeoIdsDTO']['beGeoIds'][0]['companyEligibleChallengesDTO']=compdto;

    LocalService.set("userProfile", changedCompId);
    LocalService.set("pamData", updatedPam);
    if (this.router.url.includes("/home/manager")) {
      this.redirectTo("home/manager/manage-challenges");
    } else {
      this.redirectTo("home/manager/manage-challenges");
    }
  }

  redirectTo(uri: string) {
    this.router
      .navigateByUrl("/home", { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }
  // get begeo ids
  geoIdOptions: [];
  getBegeoId() {
    this.beGeoIDfilteredOptions = this.begeoIdControl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (value != null) {
          return typeof value === "string" ? value : value;
        }
      }),
      map((name) =>
        name ? this._GeoIDfilter(name) : this.beGeoIDoptions.slice()
      )
    );
    this.begeoIdControl.enable();
    this.begeoidSpinnerFlag = false;
  }

  getStates() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (value != null) {
          return typeof value === "string" ? value : value;
        }
      }),
      map((name) => (name ? this._filter(name) : this.options.slice()))
    );
    this.countrySpinnerFlag = false;
    this.myControl.enable();
  }
  private _filter(name: any) {
    const filterValue = name.toLowerCase();
    // Change to get countries options list on click
    // return this.options.filter((option) =>
    //   option.toLowerCase().includes(filterValue)
    return this.options.filter((option, i, countries) => {
      if (
        option.toLowerCase().includes(filterValue) &&
        option.toLowerCase() !== filterValue
      ) {
        return option;
      }
      if (countries.indexOf(filterValue.toUpperCase()) > -1) {
        return option;
      }
    });
  }

  private _GeoIDfilter(value: string): string[] {
    const filterValue = value.toLowerCase().split("-")[0];

    return this.beGeoIDoptions.filter((beGeoIDoptions) =>
      // Change to get auto complete data with both numerics and alphabets
      // beGeoIDoptions.beGeoId.toLowerCase().includes(filterValue)
      beGeoIDoptions.partnerNameBegeoId.toLowerCase().includes(filterValue)
    );
  }
  regionSpinner: boolean = true;
  countrySpinnerFlag: boolean = false;
  begeoidSpinnerFlag: boolean = false;
  getRegionList() {
    this.myControl.disable();
    this.dashboardService
      .getRegionList(this.userData.username)
      .subscribe((data) => {
        this.regionsList = data.theaters;
        this.regionSpinner = false;
        this.regionName = this.pamUserData ? this.pamUserData.theater : null;
        if (this.regionName) {
          this.getCountryList("Rdata");
        }
      });
  }
  getCountryList(val?: any) {
    this.myControl.disable();
    this.begeoIdControl.disable();
    this.countrySpinnerFlag = true;
    this.filteredOptions = null;
    this.dashboardService
      .getCountryListRequest(this.userData.username, this.regionName)
      .subscribe((data) => {
        this.options = data["countryGroups"];
        this.myControl.setValidators(forbiddenNamesValidator(this.options));
        this.getStates();
        if (val == "Rdata") {
          //this.selectedRegion=this.regionName;
          this.myControl.setValue(this.pamUserData.countryGroup);
          this.onChangeCountry(this.pamUserData.countryGroup, "CData");
        } else {
          this.myControl.enable();
          this.myControl.setValue("");
          this.begeoIdControl.disable();
          this.begeoIdControl.setValue("");
        }
      });
  }

  // service call to get begeoid
  countrValue;
  onChangeCountry(value, val?: any) {
    this.begeoidSpinnerFlag = true;
    this.countrValue = value;
    let paramReq: any = {};
    paramReq.username = this.userData.username;
    paramReq.countries = [value];
    this.dashboardService.getBeGeoIdsRequest(paramReq).subscribe((data) => {
      this.beGeoIDoptions = data["beGeoIds"];
      this.begeoIdControl.setValidators(
        forbiddenBegeoIDValidator(this.beGeoIDoptions)
      );
      this.getBegeoId();
      if (val == "CData") {
        // this.selectedCountry=value;
        this.begeoIdControl.setValue(
          this.pamUserData.pamBeGeoIdsDTO.beGeoIds[0].partnerNameBegeoId
        );
        //this.selectedBgeoId=this.pamUserData.pamBeGeoIdsDTO.beGeoIds[0].beGeoId+'-'+this.pamUserData.pamBeGeoIdsDTO.beGeoIds[0].partnerName;
      } else {
        this.begeoIdControl.setValue("");
        this.begeoIdControl.enable();
      }
    });
  }

  onChangeRole() {
    this.storeService.bannerData.next("banner");
  }

  //After updating profile show pam popup for pam user
  openDialog() {
    let dialogRef = this.dialog.open(WelcomepageDialogComponent, {
      data: { data: "pamProfilePopup" },
    });
  }
  closeyourpartnerinfo() {
    this.showBeGeoIds = false;
    this.regionSpinner = true;
  }
  ngOnDestroy() {
    this.userActivatedSubscription.unsubscribe();
    this.subscription.unsubscribe();
  }

  partnerLeaderSel() {
    this.isCiscoAdmin = false;
  }
  isCiscoAdminFun() {
    this.isCiscoAdminText = true;
  }
  partnerLeaderFlag = false;
  approverRoleStatus: boolean = false;
  userNavigation(val) {
    console.log("val", this.badgingAcessControl, val);
    this.storeService.bannerData.next("banner");
    if (val == "createsaleschg") {
      this.getAcknowledgements("LEADER");
      this.isCiscoAdminText = true;
      this.storeService.setCiscoAdminFlag(true, true);
      this.userData.createSalesChg = true;
      LocalService.set("userProfile", this.userData);
      this.partnerLeaderFlag = false;
      this.approverRoleStatus = false;
      this.dropdownOptions = [];
    } else if (val == "manager") {
      this.getAcknowledgements("LEADER");
      this.partnerLeaderFlag = true;
      this.storeService.setCiscoAdminFlag(false, false);
      this.isCiscoAdminText = false;
      this.userData.createSalesChg = false;
      LocalService.set("userProfile", this.userData);
      this.approverRoleStatus = false;
      if (this.dropdownOptions.length == 0) {
        this.setMonetaryBadgingDropdown();
      }
    } else if (val == "seller") {
      this.getAcknowledgements("SELLER");
      this.approverRoleStatus = false;
      this.partnerLeaderFlag = false;
      this.isCiscoAdminText = false;
      if (this.dropdownOptions.length == 0) {
        this.setMonetaryBadgingDropdown();
      }
    } else if (val == "approver") {
      this.approverRoleStatus = true;
      this.partnerLeaderFlag = false;
      this.switchRole = "approver";
      this.isCiscoAdminText = false;
    } else {
      this.storeService.setCiscoAdminFlag(false, false);
      this.isCiscoAdminText = false;
      this.userData.createSalesChg = false;
      this.partnerLeaderFlag = false;
      LocalService.set("userProfile", this.userData);
      this.approverRoleStatus = false;
    }
  }

  // Show the popup for acknowledgement
  getAcknowledgements(role) {
    this.acknowledgementService
      .getAcknowledgements(role)
      .subscribe((response) => {
        let revResponse = response.slice().reverse();
        if (revResponse.length > 0) {
          let dialogRef;
          revResponse.forEach((element) => {
            dialogRef = this.dialog.open(AcknowldgementDialogComponent, {
              data: { name: "acknowledgePopup", responseData: element },
              width: "600px",
              disableClose: true,
              panelClass: "acknowldgment",
            });
          });

          dialogRef.afterClosed().subscribe((result) => {});
        }
      });
  }

  getcompanyPrefById() {
    const companyParams = {
      companyId:
        this.userData.userType == "PAM"
          ? this.userData.pamDefaultSelection.pamBeGeoIdsDTO.beGeoIds[0]
              .companyId
          : this.userData.company.id,
    };
    this.managerService
      .getCompanyPreferences(companyParams)
      .subscribe((data) => {
        if (data) {
          this.preferenceService.updateOptions(data.companyPreferences);
        }
        console.log("comp pref res", data);
      });
  }
  onAccessControlChange(eve) {
    console.log(eve);
    this.preferenceService.setSelectedOption(eve.value);
    LocalService.set("incentiveProgram", eve.value);
    this.commonRouteService.navigateIncenticveProgram(
      this.userData,
      this.badgingAcessControl
    );
  }
  setMonetaryBadgingDropdown() {
    this.preferenceService.preferenceOptions.subscribe((options) => {
      this.dropdownOptions = options.map((opt) => {
        if (opt === "COMPANY_MONETARY_INCENTIVES") return "Monetary Incentives";
        if (opt === "COMPANY_BADGING") return "Medals";
        return opt;
      });
      if (this.dropdownOptions.length > 0) {
        if (this.dropdownOptions.includes("Monetary Incentives")) {
          this.badgingAcessControl = "Monetary Incentives";
        } else {
          console.log("bading");
          this.badgingAcessControl = "Medals";
        }
      } else {
        this.dropdownOptions.push("Monetary Incentives");
        this.badgingAcessControl = "Monetary Incentives";
      }
      this.commonRouteService.navigateIncenticveProgram(
        this.userData,
        this.badgingAcessControl
      );
      console.log("dropdownoptions", this.dropdownOptions);
      LocalService.set("incentiveProgram", this.badgingAcessControl);
      this.preferenceService.setSelectedOption(this.badgingAcessControl);
    });
  }
}
